import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Backdrop, CircularProgress } from "@mui/material";

import Modal from "./Modal";

export default function ToggleModal({ name, url, children }) {
    const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);

    return (
        <>
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={isOpenBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Modal
                productName={name}
                pdfDocUrl={url}
                handleSetBackdrop={(bool) => setIsOpenBackdrop(bool)}
            />
            {children}
        </>
    );
}
